import React, { useCallback, useContext, useState } from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter, Redirect } from "react-router-dom";
import firebaseApp from "../../firebase";
import { AuthContext } from "../../context/AuthContext";
import { ReactComponent as Error } from "../../img/icons/error.svg";
import { ReactComponent as LogoMapsser } from "../../img/icons/logoMappser.svg";

import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  card: {
    overflow: "visible",
  },
  session: {
    position: "relative",
    zIndex: 4000,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  background: {
    backgroundColor: "#FF7D00",
  },
  content: {
    padding: `40px ${theme.spacing(1)}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "1 0 auto",
    flexDirection: "column",
    minHeight: "100%",
    textAlign: "center",
  },
  wrapper: {
    flex: "none",
    maxWidth: "500px",
    width: "100%",
    margin: "0 auto",
  },
  errorWrapper: {
    margin: "20px auto 15px",
    backgroundColor: "#FFEBD8",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 20px",
    textAlign: "left",
  },
  errorIcon: {
    marginRight: "10px",
    width: "40px",
  },
  fullWidth: {
    width: "100%",
  },
  checkbox: {
    marginBottom: "20px",
  },
  logo: {
    display: "flex",
    flexDirection: "column",
  },
  buttonBackground: {
    backgroundColor: "#FF7D00",
    '&:hover': {
      background: "#D46800",
   },
  },
  cardContent: {
    padding: "60px 80px !important",
    [theme.breakpoints.down("sm")]: {
      padding: "60px 40px !important",
    },
  },
  input: {
    marginTop: "10px",
    "&input": {
      "&:after": {
        borderBottom: "2px solid #FF7D00",
      },
    },
    "&:after": {
      borderBottom: "2px solid #FF7D00",
    },
  },
  checkInput: {
    "& svg": {
      fill: "#FF7D00 !important",
    },
  },
  logoWrapper: {
    width: '100%',
    marginBottom: '20px',
    textAlign: 'center',
  }
}));

const Login = ({ history }) => {
  const [error, setError] = useState(false);
  const classes = useStyles();

  const handleLogin = useCallback(
    async (event) => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      try {
        await firebaseApp
          .auth()
          .signInWithEmailAndPassword(email.value, password.value);
        history.push("/");
      } catch (error) {
        setError(error);
      }
    },
    [history]
  );

  const { currentUser } = useContext(AuthContext);
  if (currentUser) {
    return <Redirect to="/" />;
  }

  return (
    <div className={classNames(classes.session, classes.background)}>
      <div className={classes.content}>
        <div className={classes.wrapper}>
          <Card>
            <CardContent className={classes.cardContent}>
              <div className={classNames(classes.logo, `text-xs-center pb-xs`)}>
                <img
                  src={`${process.env.PUBLIC_URL}/static/images/logo-simulacro.svg`}
                  alt=""
                  className="block"
                />
              </div>
              {error && (
                <div className={classes.errorWrapper}>
                  <Error className={classes.errorIcon} />
                  <Typography variant="subtitle1">
                    El correo o la contraseña no son correctos, intenta
                    nuevamente.
                  </Typography>
                </div>
              )}

              <form onSubmit={handleLogin}>
                <TextField
                  id="email"
                  label="Correo Electrónico"
                  className={classNames(classes.textField, classes.input)}
                  fullWidth
                  margin="normal"
                  required
                />
                <TextField
                  id="password"
                  label="Contraseña"
                  className={classNames(classes.textField, classes.input)}
                  type="password"
                  fullWidth
                  margin="normal"
                  required
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="checkedA"
                      className={classNames(classes.checkInput)}
                    />
                  }
                  label="Recordar cuenta en este dispositivo"
                  className={classNames(classes.fullWidth, classes.checkbox)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                  className={classNames(classes.buttonBackground)}
                >
                  Iniciar Sesión
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className={classes.logoWrapper}>
      <LogoMapsser />
      </div>
    </div>
  );
};

export default withRouter(Login);
